import axios from "axios";

export const API_CORE = axios.create({
  baseURL: "https://gnzs-core-api.uts2.ks.ua",
  validateStatus(status) {
    return status >= 200 && status < 300;
  },
});
